

import { hnAPI } from '../../constants/api';
import { HN_TEXTS } from '../../constants'
import fetchApi from '../../services/fetch';
import { track, updateGlobalTracker, generateServerResponseError, generateMessageDisplayedSegment } from 'utils/segmenTracker';
import { ACTIVATION, OTP_FAILED, SERVER_RESPONSE_FAILED, MESSAGE_DISPLAYED} from 'constants/segmentEvents'


const initialState = {
    otpStatus: {
        received: false,
        verified: false
    }
};

export const otp = {
    state: { ...initialState },
    reducers: {
        updateStatus(state, payload) {
            return {
                ...state,
                otpStatus: { ...state.otpStatus, ...payload }
            };
        },
        clearStatus() {
            return { ...initialState }
        }
    },
    effects: dispatch => {
        return {
            async getOTP({callback, type, ...params }) {
                dispatch.apiStatus.setProcessing(true);
                this.clearStatus();
                return fetchApi({
                    method: "POST",
                    url: hnAPI.otp,
                    data: { ...params }
                })
                    .then(() => {
                        dispatch.apiStatus.setProcessing(false);
                        this.updateStatus({ received: true })
                        callback && callback();
                    })
                    .catch(error => {
                        dispatch.apiStatus.setRequestFailed({ ...error });
                        track(OTP_FAILED, { journey: ACTIVATION });
                        track(SERVER_RESPONSE_FAILED, {...generateServerResponseError(error, ACTIVATION, `Verify ${type}`, hnAPI.otp, 'Get OTP API' )})
                        track(MESSAGE_DISPLAYED, {...generateMessageDisplayedSegment(error, ACTIVATION, 'Get OTP API')})
                    });
            },
            async verifyOTP({ callback, type, ...params }) {
                this.clearStatus();
                dispatch.apiStatus.setProcessing(true);
                return fetchApi({
                    method: "POST",
                    url: hnAPI.validateOTP,
                    data: { ...params }
                })
                    .then((response) => {
                        const { data: {  action = '' } = {} } = response;
                        if(action.toLowerCase() === HN_TEXTS.HN_OTP_VALIDATION_SUCCESS.toLowerCase()) {
                            this.updateStatus({ verified: true })
                            callback && callback();
                            if(type === 'email') {
                                updateGlobalTracker({ 'email OTP status': 'verfied'})
                            }
                            else {
                                updateGlobalTracker({ 'phone OTP status': 'verfied'})
                            }
                            return
                        }
                        track(OTP_FAILED, { journey: ACTIVATION, otp_channel: type === 'email' ? 'email' : 'SMS' })
                       dispatch.apiStatus.setRequestFailed({ message: 'Tu código es incorrecto, inténtalo de nuevo' });
                    })
                    .catch(error => {
                        track(OTP_FAILED, { journey: ACTIVATION, otp_channel: type === 'email' ? 'email' : 'SMS' })
                        dispatch.apiStatus.setRequestFailed({ ...error });
                        track(SERVER_RESPONSE_FAILED, {...generateServerResponseError(error, ACTIVATION, `Verify ${type}`, hnAPI.validateOTP, 'Verify OTP API' )})
                        track(MESSAGE_DISPLAYED, {...generateMessageDisplayedSegment(error, ACTIVATION, 'Verify OTP API')})
                    });
            }
        };
    }
}
